import React from 'react'
import Manager from '../../../public/components/Manager'
import SupplierEvaluateDiv from './SupplierEvaluateDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [],
    columns: [
        { _text: '评价编号', field: 'SupplierEvaluateApply.Number', search: true, flex: 1, locked: false },
        { _text: '供应商名称', field: 'SupplierName', search: true, flex: 1 },
        { _text: '申请原因', field: 'SupplierEvaluateApply.Reason', flex: 1 },
        { _text: '待平分人', field: 'TaskExecutor', flex: 1 },
        { _text: '状态', field: 'StatusName', flex: 1, search: true, flex: 1, },
    ],
    onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierEvaluateDiv {...props} id={data.id} bReadOnly={true} />),
}

export default props => <Manager {...props} config={config} />